export enum SearchTypesType {
    DEFAULT = 1,
    SEARCH,
    DATE_RANGE,
}
